import { ServiceHandler, applyQueryConfig } from '../utils/api.utils';
import { standardQuerySerializer } from '../api/serializers/query.serializers';
import { commonDateParamMappings } from '../api/common/mappings';

const remittanceSearchMappings = [
  { path: 'page' },
  { path: 'size' },
  { path: 'search' },
  {
    paramKey: 'sort',
    transform: ({ orderBy, order }: any) => {
      const newOrder = order || 'asc';
      return orderBy ? `${orderBy},${newOrder}` : null;
    },
  },
  ...commonDateParamMappings,
];

export const getRemittances = ServiceHandler({
  url: '/api/billing/v1/remittance/search',
  paramsSerializer: (params) =>
    standardQuerySerializer(applyQueryConfig(remittanceSearchMappings, params)),
});

export const deleteRemittance = ServiceHandler({
  url: '/api/billing/v1/remittance/:remittanceId',
  method: 'DELETE',
});

export const createRemittance = ServiceHandler({
  url: '/api/billing/v1/remittance',
  method: 'POST',
});

